import {
  Box,
  type BoxProps,
  Link,
  type LinkProps,
  Text,
  type TextProps,
  Tooltip,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isURLMatch } from '@ui/util';
import { Link as RouterLink, useLocation } from 'react-router';

import { useNavigationContext } from './context';
import type { NavigationItem } from './types';

type ItemProps = NavigationItem & {
  containerProps?: BoxProps;
  textProps?: TextProps;
  linkProps?: LinkProps;
  matchSearch?: boolean;
  title?: string;
};

export function Item({
  label,
  path,
  icon,
  containerProps = {},
  textProps = {},
  linkProps = {},
  matchSearch = false,
  title,
}: ItemProps) {
  const { search, pathname } = useLocation();
  const { isOpen } = useNavigationContext();

  const isActive = isURLMatch(
    new URL(pathname + search, 'http://localhost'),
    new URL(path, 'http://localhost'),
    matchSearch,
  );

  return (
    <Link
      key={path.replace('/', '')}
      as={RouterLink}
      to={path}
      width="100%"
      height="50px"
      alignItems="center"
      display="flex"
      textDecoration="none !important"
      title={title ?? label}
      justifyContent={isOpen ? 'flex-start' : 'center'}
      color="mw.white"
      opacity={isActive ? 1 : 0.72}
      _hover={{
        opacity: 1,
      }}
      margin={0}
      {...linkProps}
    >
      <Box
        display={isOpen ? 'flex' : 'inline-block'}
        fontSize={16}
        alignItems="center"
        {...containerProps}
      >
        <Tooltip label={label} placement="right" isDisabled={isOpen}>
          <FontAwesomeIcon icon={icon} width={36} />
        </Tooltip>

        <Text
          display="inline-block"
          opacity={isOpen ? 1 : 0}
          maxWidth={isOpen ? 'unset' : 0}
          maxHeight={isOpen ? 'unset' : 0}
          wordBreak="break-word"
          overflow="hidden"
          marginLeft={isOpen ? 3 : 0}
          fontSize=".875rem"
          fontWeight="semibold"
          fontFamily="navigationItem"
          {...textProps}
        >
          {label}
        </Text>
      </Box>
    </Link>
  );
}
